import React, { useEffect } from 'react'
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import TagListComponent from './TagListComponent';

export default function ListTags() {
    const {
        fetchTags,
        tags,
        tagsLoading,
    } = useTagsHook();
    useEffect(() => {
        fetchTags();
    }, [])
    if (tagsLoading === true || tags === null) {
        return <div className='flex justify-center items-center min-h-64'>
            <div className='text-xl font-semibold text-gray-600'>Loading...</div>
        </div>
    };
    return (
        <div className='flex justify-start items-center flex-col min-h-screen bg-gray-50 py-8'>
            <h1 className='text-3xl font-bold my-8 text-gray-800'>
                List All Tags
            </h1>
            <div className='flex flex-col items-center justify-start gap-2 max-w-2xl w-[600px] px-4'>
                {tags.data.map((tag: any, index: number) => {
                    return (
                        <TagListComponent
                            key={index}
                            tag={tag}
                            tagIndex={index}
                            type="LIST"
                        />
                    )
                })}
            </div>
            {tags.data.length === 0 && (
                <div className='text-lg text-gray-500 mt-8'>
                    No tags added yet.
                </div>
            )}
        </div>
    )
}
